import { startOfDay, endOfDay } from "date-fns";
import { utcToZonedTime, zonedTimeToUtc, toDate, formatInTimeZone } from "date-fns-tz";
import { isEmpty } from "./helpers";

/**
 *
 * @param {Date|String|Number} date - the date with values representing the local time
 * @param {String} tzOffset - the time zone offset with respect to which day start in required
 * @returns Date - Start of Day
 */
export const zonedStartOfDay = (date, tzOffset) => {
  if (!date || !tzOffset) return;

  const input = toDate(date);

  const inputZoned = utcToZonedTime(input, tzOffset);

  const dayStartZoned = startOfDay(inputZoned);

  const dayStart = zonedTimeToUtc(dayStartZoned, tzOffset);

  return dayStart;
};

/**
 *
 * @param {Date|String|Number} date - the date with values representing the local time
 * @param {String} tzOffset - the time zone offset with respect to which day start in required
 * @returns Date - End of Day
 */
export const zonedEndOfDay = (date, tzOffset) => {
  if (!date || !tzOffset) return;

  const input = toDate(date);

  const inputZoned = utcToZonedTime(input, tzOffset);

  const dayEndZoned = endOfDay(inputZoned);

  const dayEnd = zonedTimeToUtc(dayEndZoned, tzOffset);

  return dayEnd;
};

/**
 *
 * @param {String} utcOffset - UTC offset string. e.g. +05:30
 * @returns offset in Minutes
 */
export const offsetInMinutes = utcOffset => {
  if (!utcOffset || typeof utcOffset !== "string") return 0;
  const isPositive = utcOffset.includes("+");
  const offset = utcOffset.substring(1).trim().replace(":", "");
  if (offset.length === 4) {
    const hours = Number(offset.substring(0, 2));
    const minutes = Number(offset.substring(2, 4));
    const finalMinutes = hours * 60 + minutes;
    return isPositive ? finalMinutes : -finalMinutes;
  }
  return 0;
};

/**
 *
 * @param {Date|String|Number} date - the date with values representing the local time
 * @param {String} tzOffset - the time zone offset with respect to which minutes since midnight is required
 * @returns Number - Minutes since midnight
 */
export const minutesSinceMidNight = (date, tzOffset) => {
  if (!date || !tzOffset) return 0;

  const input = toDate(date);

  return Number(formatInTimeZone(input, tzOffset, "HH")) * 60 + Number(formatInTimeZone(input, tzOffset, "mm"));
};

export const formatDate = (date, utcOffset) => format(date, utcOffset, "MMM dd, yy");

export const formatTime = (date, utcOffset) => format(date, utcOffset, "hh:mm a");

export const formatDateTime = (date, utcOffset) => format(date, utcOffset, "MMM dd, yy hh:mm a");

export const format = (date, utcOffset, pattern) => {
  if (!date || !utcOffset || typeof utcOffset !== "string" || isEmpty(pattern)) return "-";
  const input = toDate(date);

  return formatInTimeZone(input, utcOffset, pattern);
};

export const getWeekDate = (date, utc_offset) => {
  const weekNo = Number(format(date, utc_offset, "w"));
  const firstSun = getFirstSunday(date, utc_offset);
  let start, end;
  if (firstSun === 1) {
    start = (weekNo - 1) * 7 + firstSun;
    end = weekNo * 7 + (firstSun - 1);
  } else {
    start = (weekNo - 2) * 7 + firstSun;
    end = (weekNo - 1) * 7 + (firstSun - 1);
  }
  const year = date.getFullYear();
  const startDate = new Date(year, 0, start);
  const endDate = new Date(year, 0, end);
  return { start: startDate, end: endDate };
};

const getFirstSunday = (date, utc_offset) => {
  const year = date.getFullYear();
  for (let i = 1; i <= 7; i++) {
    const d = new Date(year, 0, i);
    if (format(d, utc_offset, "iii") === "Sun") {
      return i;
    }
  }
};
